<template>
  <div>
    <div v-if="type=='view'" class="ec-form--view">{{val !== '' ? val : defaultVal}}</div>
    <el-input
      v-else
      v-bind="$attrs"
      v-bind:value="val"
      v-on="inputListeners">
    </el-input>
  </div>
</template>
<script>
export default {
  name: "EcFormInput",
  data() {
    return {
    };
  },
  model: {
    prop: 'val',
    event: 'input'
  },
  props: {
    val: {
      type: [String, Number, Object],
      default: ''
    },
    defaultVal: {
      type: String,
      default: ''
    }
  },
  inject: {
    elForm: {
      default: ''
    },
  },
  computed: {
    inputListeners: function () {
      var vm = this
      // `Object.assign` 将所有的对象合并为一个新对象
      return Object.assign({},
        // 我们从父级添加所有的监听器
        this.$listeners,
        // 然后我们添加自定义监听器，
        // 或覆写一些监听器的行为
        {
          // 这里确保组件配合 `v-model` 的工作
          input (event) {
            vm.$emit('input', event)
          }
        }
      )
    },
    type () {
      return this.elForm && this.elForm.$attrs && this.elForm.$attrs.type || ''
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/EcFormInput/src/index.vue